/** 浏览器插件登录桥：登录成功后通知父窗口 / 插件 */
import { getFundingToken } from './api';

export function isIpePluginEmbed() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('ipe_plugin') === '1';
}

export function isIpePluginSilentCheck() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('silent') === '1';
}

export function notifyIpePluginAuthSuccess(extra = {}) {
  if (!isIpePluginEmbed()) return;
  const token = getFundingToken();
  if (!token) return;

  const payload = {
    type: 'IPE_PLUGIN_AUTH',
    token,
    apiHost: `${window.location.protocol}//${window.location.host}`,
    ...extra,
  };

  postPluginMessage(payload);
  dispatchPluginEvent('ipe-plugin-auth-success', payload);
}

export function notifyIpePluginAdminAuthSuccess(extra = {}) {
  if (!isIpePluginEmbed()) return;
  let token = null;
  try {
    token = localStorage.getItem('ipe_admin_token');
  } catch {
    token = null;
  }
  if (!token) return;

  const payload = {
    type: 'IPE_PLUGIN_ADMIN_AUTH',
    token: String(token).trim(),
    apiHost: `${window.location.protocol}//${window.location.host}`,
    ...extra,
  };

  postPluginMessage(payload);
  dispatchPluginEvent('ipe-plugin-admin-auth-success', payload);
}

function postPluginMessage(payload) {
  try {
    window.parent?.postMessage(payload, '*');
  } catch {
    /* ignore */
  }
}

function dispatchPluginEvent(name, detail) {
  try {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  } catch {
    /* ignore */
  }
}
